import { Cart, ItemBody } from '@adapters/bigcommerce/types/cart';

const klaviyoAddToCart = async ({
  data,
  item,
  categories = [],
}: {
  data: Cart;
  item?: ItemBody;
  categories?: string[];
}) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { _learnq = [] } = window;

  const Items = Object.values(data?.cartData?.line_items ?? {})
    .flatMap((category) => category)
    .map((cartItem) => ({
      ProductID: cartItem.code,
      SKU: cartItem.sku,
      ProductName: cartItem.name,
      Quantity: cartItem.quantity,
      ItemPrice: cartItem.sale_price,
      RowTotal: cartItem.extended_sale_price,
      ProductURL: cartItem.url,
      ImageURL: cartItem.image_url,
      _variant_item_id: cartItem.variant_id,
    }));

  const addedItem = Items.find((el) => el._variant_item_id === item?.variantId);

  const eventData = {
    $value: data?.cartData?.base_amount,
    AddedItemProductName: addedItem?.ProductName,
    AddedItemProductID: addedItem?.ProductID,
    AddedItemSKU: addedItem?.SKU,
    AddedItemCategories: categories,
    AddedItemImageURL: addedItem?.ImageURL,
    AddedItemURL: addedItem?.ProductURL,
    AddedItemPrice: addedItem?.ItemPrice,
    AddedItemQuantity: addedItem?.Quantity,
    ItemNames: Items.map((el) => el.ProductName),
    CheckoutURL: data?.cartData?.redirect_urls.checkout_url,
    Items,
  };

  _learnq.push(['track', 'Added to Cart', eventData]);
};

export default klaviyoAddToCart;
